<template>
    <mini-table ref="duTree"
                read-only
                enable-table-tree
                tree-id-name="id"
                tree-parent-id-name="parentId"
                tree-node-label-name="name"
                :default-expend-depth="1"
                without-level
                enableTreeCheck
                :items="deptUserTreeNodes"
                :fields="fields"
                disable-first-index-column
                with-custom-actions-end-of-row
                addition-columns="#name"
                :loading="loading"
                @rowChecked="$emit('checkChanged', $event)">
        <template #addition(name)="{row}">
            <div class="m-tb-auto mr-1">
                <i v-if="row.id.startsWith(deptPrefix)" class="fa-solid fa-building-user" style="color: #198d3f"></i>
                <i v-else-if="row.id.startsWith(userPrefix)" class="fa-solid fa-person" style="color: #5280e8"></i>
            </div>
        </template>
        <template #endOfRow="{row}">
            <slot name="endOfRow" :row="row"></slot>
        </template>
    </mini-table>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";

export default {
    name: "DeptUserTreeMT",
    components: {MiniTable},
    mixins: [EmCommonApi],
    props: {
        deptId: {
            type: [String, Number],
            default: ""
        },
        deptNodeCode: {
            type: String,
            default: ""
        },
        customApi: {
            type: String,
            default: "deptUserTree"
        },
        selectedId: {
            type: [String, Number],
            default: ""
        },
    },
    data() {
        return {
            loading: false,
            deptUserTreeNodes: [],
            userPrefix: "user_",
            deptPrefix: "dept_",
            fields: [
                {key: 'name', label: 'Name'}
            ],
            checkedIdSet: new Set(),
            userWeight: {},
        }
    },
    methods: {
        getDeptUserTreeNodes(deptId, deptNodeCode) {
            let entityApi = this.$_emApiMixin_entityBaseApi("emAclUser");
            let url = this.customApi === "deptUserTree" ? `${entityApi}/${this.customApi}` : this.customApi
            this.loading = true;
            this.$_emApiMixin_post(url, {
                emAclDeptIdFilter: deptId,
                emAclDeptNodeCodeFilter: deptNodeCode
            }).then((response) => {
                // console.log(response.data)
                this.deptUserTreeNodes = response.data
                this.initSelectedId();
            }).finally(() => this.loading = false);
        },
        getUserIds() {
            let userNodes = this.$refs.duTree.getCheckedRows();
            let v = "";
            for (let item of userNodes) {
                if (item.id.startsWith(this.userPrefix)) {
                    v += "," + item.userId;
                }
            }
            return v.length > 0 ? v.substring(1) : v;
        },
        getUserNodes() {
            return this.$refs.duTree.getCheckedRows();
        },
        initSelectedId() {
            let tempList = this.selectedId.split(",");
            for (let item of tempList) {
                item = this.userPrefix + item;
            }
            this.$refs.duTree.initCheckStatus(tempList);
        },
    },
    mounted() {
        this.getDeptUserTreeNodes(this.deptId, this.deptNodeCode)
    }
}
</script>

<style scoped>

</style>
